import React from 'react';
import { Search, Share, Scissors, ArrowRight } from 'lucide-react';

export const SearchIcon: React.FC = () => (
  <Search size={40} color="white" />
);

export const ShareIcon: React.FC = () => (
  <Share size={40} color="white" />
);

export const ClipIcon: React.FC = () => (
  <Scissors size={40} color="white" />
);

export const ButtonArrowIcon: React.FC = () => (
  <ArrowRight size={20} />
); 